import { CORPORATESECTORLIST_SEARCH, CORPORATESECTORLIST_PAGE } from '../actions/corporatesectorlistactions';

const state = { search: '', page: 0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [CORPORATESECTORLIST_SEARCH]: ({ commit }, search) => {
        commit(CORPORATESECTORLIST_SEARCH, search);
    },
    [CORPORATESECTORLIST_PAGE]: ({ commit }, page) => {
        commit(CORPORATESECTORLIST_PAGE, page);
    }
};

const mutations = {
    [CORPORATESECTORLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [CORPORATESECTORLIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};